<template>
  <div>
    <h3 class="mb-5">Main Messaging</h3>
    <div class="h4 mb-5">顯示於Career Page頁面</div>
    <div>
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.title }}
        </div>
      </div>
      <!-- SubTitle -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.subtitle }}
        </div>
      </div>
      <!-- Call To Actiom -->
      <div class="form-item d-flex py-5">
        <h4 class="w-180px">Call To Action</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ career.call_to_action }}
        </div>
      </div>
      <!-- img -->
      <div class="px-5 d-flex py-5">
        <h4 class="w-180px">Background</h4>
        <div class="flex-grow-1 d-flex justify-end">
          <div
            class="w-305px h-187px"
            :style="{
              'background-image': `url(${career.background})`,
              'border-radius': '6.2px',
              'background-size': 'contain',
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
